module.exports = __webpack_public_path__ + "img/wbms.9a867be8.jpeg";